import { render, staticRenderFns } from "./PopupMessageAuth.vue?vue&type=template&id=2202912b&scoped=true"
import script from "./PopupMessageAuth.vue?vue&type=script&lang=js"
export * from "./PopupMessageAuth.vue?vue&type=script&lang=js"
import style0 from "./PopupMessageAuth.vue?vue&type=style&index=0&id=2202912b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2202912b",
  null
  
)

export default component.exports